import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCustomerAuthStore } from '../stores/auth'

export function CustomerAuthCallbackPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const setTokens = useCustomerAuthStore((s) => s.setTokens)

  useEffect(() => {
    const accessToken = params.get('accessToken')
    const refreshToken = params.get('refreshToken')
    const userId = params.get('userId')
    const email = params.get('email')
    const name = params.get('name')
    const customerId = params.get('customerId')
    const impersonation = params.get('impersonation') === '1'

    if (!accessToken || !userId || !email || !name) {
      navigate('/login?error=m365_error', { replace: true })
      return
    }

    setTokens({
      accessToken,
      refreshToken: refreshToken ?? null,
      user: { id: userId, email, name, customerId: customerId || null },
      isImpersonation: impersonation,
    })
    navigate('/', { replace: true })
  }, [params, navigate, setTokens])

  return (
    <div className="min-h-screen flex items-center justify-center text-gray-500">
      Anmeldung wird abgeschlossen …
    </div>
  )
}
